import styled, { createGlobalStyle, css } from 'styled-components'
import { colors } from './content'

/* The design pair (desktop + 430px-wide mobile artboard) breaks at the same
   769px the rest of the landing components use. */
export const MOBILE = '@media (max-width: 769px)'

/* dir is forced on the element AND in CSS: the header language toggle clears
   document.dir when switching to English, and this page must never flip. */
export const RtlPage = styled.div`
	direction: rtl;
	background: ${colors.paper};
	color: ${colors.navy};
	overflow-x: hidden;
	width: 100%;
	::selection {
		background: ${colors.amber};
		color: ${colors.navy};
	}
`

/* Body-level clearance so the fixed bottom action bar never covers the
   platform footer (which renders outside this page's container). */
export const StickyBarClearance = createGlobalStyle`
	${MOBILE} {
		body {
			padding-bottom: 76px;
		}
	}
`

export const Container = styled.div`
	max-width: 1180px;
	margin: 0 auto;
	padding: 0 32px;
	${MOBILE} {
		padding: 0 18px;
	}
`

export const Kicker = styled.div<{ color?: string }>`
	font-size: 13px;
	font-weight: 600;
	letter-spacing: 0.14em;
	color: ${p => p.color ?? colors.blue};
	margin-bottom: 18px;
	${MOBILE} {
		font-size: 11px;
		margin-bottom: 12px;
	}
`

export const pillBase = css`
	display: inline-block;
	font-family: inherit;
	font-weight: 700;
	font-size: 16px;
	padding: 14px 30px;
	border-radius: 999px;
	border: none;
	cursor: pointer;
	text-align: center;
	line-height: 1.2;
	${MOBILE} {
		font-size: 17px;
		padding: 16px 24px;
		width: 100%;
	}
`

export const AmberPill = styled.button`
	${pillBase}
	background: ${colors.amber};
	color: ${colors.navy};
	&:hover {
		filter: brightness(1.08);
	}
`

export const LightOutlinePill = styled.button`
	${pillBase}
	background: transparent;
	border: 1.5px solid rgba(245, 245, 245, 0.4);
	color: ${colors.paper};
	padding: 13px 28px;
	&:hover {
		background: rgba(245, 245, 245, 0.1);
		border-color: ${colors.paper};
	}
	${MOBILE} {
		padding: 15px 24px;
	}
`

export const NavyPill = styled.button`
	${pillBase}
	background: ${colors.navy};
	color: ${colors.paper};
	&:hover {
		background: ${colors.navyDeep};
	}
`

export const NavyOutlinePill = styled.button`
	${pillBase}
	background: transparent;
	border: 1.5px solid rgba(22, 58, 132, 0.45);
	color: ${colors.navy};
	padding: 13px 28px;
	&:hover {
		border-color: ${colors.navy};
		background: rgba(22, 58, 132, 0.08);
	}
	${MOBILE} {
		padding: 15px 24px;
	}
`
